import { render, staticRenderFns } from "./AddStatisticsBanner.vue?vue&type=template&id=5d74ad3f"
import script from "./AddStatisticsBanner.vue?vue&type=script&lang=js"
export * from "./AddStatisticsBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports